import { __assign as o } from "./index60.mjs";
import { ErrorKind as a } from "./index55.mjs";
import { Parser as l } from "./index56.mjs";
import { isSelectElement as s, isPluralElement as m, isNumberElement as u, isNumberSkeleton as f, isDateElement as E, isTimeElement as c, isDateTimeSkeleton as d, isTagElement as v } from "./index57.mjs";
import { SKELETON_TYPE as L, TYPE as k, isArgumentElement as x, isLiteralElement as N, isPoundElement as _ } from "./index57.mjs";
function n(r) {
  r.forEach(function(e) {
    if (delete e.location, s(e) || m(e))
      for (var i in e.options)
        delete e.options[i].location, n(e.options[i].value);
    else u(e) && f(e.style) || (E(e) || c(e)) && d(e.style) ? delete e.style.location : v(e) && n(e.children);
  });
}
function T(r, e) {
  e === void 0 && (e = {}), e = o({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, e);
  var i = new l(r, e).parse();
  if (i.err) {
    var t = SyntaxError(a[i.err.kind]);
    throw t.location = i.err.location, t.originalMessage = i.err.message, t;
  }
  return e != null && e.captureLocation || n(i.val), i.val;
}
export {
  L as SKELETON_TYPE,
  k as TYPE,
  x as isArgumentElement,
  E as isDateElement,
  d as isDateTimeSkeleton,
  N as isLiteralElement,
  u as isNumberElement,
  f as isNumberSkeleton,
  m as isPluralElement,
  _ as isPoundElement,
  s as isSelectElement,
  v as isTagElement,
  c as isTimeElement,
  T as parse
};
